import { Component, OnInit } from "@angular/core";
import { Message } from "../../../models/message";
import { Router, ActivatedRoute, Params } from "@angular/router";
import { AuthService } from "../../../core/auth.service";
import { MessagingService } from "../../../services/messaging.service";
import { ActivationEnd } from "@angular/router/src/events";

@Component({
  selector: "app-message-form",
  templateUrl: "./message-form.component.html",
  styleUrls: ["./message-form.component.css"]
})
export class MessageFormComponent implements OnInit {
  message: Message = {
    sendFrom: {},
    sendTo: "",
    title: "",
    body: "",
    active: true,
    archived: false
  };

  allMessages;

  routerId;
  userObject: object;
  destroyForm: boolean = true;

  _ref: any;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    public auth: AuthService,
    private messagingService: MessagingService
  ) {
    this.userObject = auth.getUserObject();
    console.log(this.userObject);
  }

  ngOnInit() {
    this.routerId = this.route.snapshot.params["id"];

    console.log(this.routerId);
    this.message.sendTo = this.routerId;
    this.message.sendFrom = this.userObject;
  }

  sendMessage(message) {
    console.log(message);
    this.destroyForm = false;
    this.messagingService.sendMessage(message);
  }

  validationForm() {
    if (this.message.title !== "" && this.message.body !== "") {
      return true;
    } else {
      return false;
    }
  }

  cancel(){
    this.destroyForm = false;
  }

}



// WEBPACK FOOTER //
// /Users/akirchhoff/Documents/Development/loveyourcamper-app/src/app/components/messaging/message-form/message-form.component.ts